export enum RequireJustificationEnum {
  NO = 'no',
  REQUIRED = 'required',
  OPTIONAL = 'optional',
}
